/** Type guard that tells you if you've got a touch event on your hands. */
var isTouch = function isTouch(event) {
  return typeof TouchEvent !== 'undefined' && typeof event !== 'undefined' && event instanceof TouchEvent;
};
/** Touch event support multitouch. We're only interested in the first (we assume this is the primary) touch. WARNING: this assumes that that touch exists. Use with caution. */

var getFirstTouch = function getFirstTouch(event) {
  return event.touches.item(0);
};
/** Given a mouse or touch event, get the screen-relative X coordinate of the touch/click */

function getX(event) {
  if (isTouch(event)) return getFirstTouch(event).screenX; // Else, it's a mouse event

  return event.screenX;
}
/** Given a mouse or touch event, get the screen-relative Y coordinate of the touch/click */

function getY(event) {
  if (isTouch(event)) return getFirstTouch(event).screenY; // Else, it's a mouse event

  return event.screenY;
}

export { getFirstTouch, getX, getY, isTouch };
